import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, Signal, viewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

export interface AgPoDropdownCustomParams extends ICellEditorParams {
  poOptions?: Signal<{ label: string; value: string }[]>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full block h-full',
  },
  imports: [NgSelectModule, FormsModule, ReactiveFormsModule],
  selector: 'aux-ag-po-dropdown',
  styleUrls: ['ag-po-dropdown.component.scss'],
  templateUrl: 'ag-po-dropdown.component.html',
})
export class AgPoDropdownComponent implements ICellEditorAngularComp {
  select = viewChild<NgSelectComponent>('select');

  formControl = new FormControl('');
  params!: AgPoDropdownCustomParams;
  poOptions?: Signal<{ label: string; value: string }[]>;

  agInit(params: AgPoDropdownCustomParams): void {
    this.params = params;
    this.formControl.setValue(params.value || null);
    this.poOptions = params.poOptions;
    setTimeout(() => this.select()?.open());
  }

  getValue(): string {
    return this.formControl.value ?? '';
  }

  onChange(): void {
    // this.params.node.setDataValue(this.params.column.getColId(), this.formControl.value);
    this.params.api.stopEditing();
    this.params.api.setFocusedCell(this.params.rowIndex, this.params.column.getColId());
  }

  refresh(): boolean {
    return true;
  }
}
